'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _capitalize2 = require('lodash/capitalize');

var _capitalize3 = _interopRequireDefault(_capitalize2);

var _isEmpty2 = require('lodash/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _mobxReact = require('mobx-react');

var _Table = require('react-bootstrap/lib/Table');

var _Table2 = _interopRequireDefault(_Table);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var truncate = _utils.FormattingUtils.truncate,
    formatDateTime = _utils.FormattingUtils.formatDateTime;


var EMAIL_TRUNCATION_LENGTH = 25;

var EmailTrackingTable = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(EmailTrackingTable, _Component);

  function EmailTrackingTable() {
    _classCallCheck(this, EmailTrackingTable);

    return _possibleConstructorReturn(this, (EmailTrackingTable.__proto__ || Object.getPrototypeOf(EmailTrackingTable)).apply(this, arguments));
  }

  _createClass(EmailTrackingTable, [{
    key: 'render',
    value: function render() {
      var item = this.props.emailDetails,
          events = (0, _get3.default)(item, 'latest_anymail_events', []);
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h3',
          { className: 'email-status-header' },
          'Email Status'
        ),
        (0, _isEmpty3.default)(events) && _react2.default.createElement(
          'p',
          { className: 'no-status-message' },
          'No email status available'
        ) || _react2.default.createElement(
          _Table2.default,
          { condensed: true, className: 'email-tracking-table' },
          _react2.default.createElement(
            'thead',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                { className: 'email-tracking-cell' },
                'Email'
              ),
              _react2.default.createElement(
                'th',
                null,
                'Status'
              )
            )
          ),
          _react2.default.createElement(
            'tbody',
            null,
            events.map(function (event, idx) {
              return _react2.default.createElement(
                'tr',
                { key: idx },
                _react2.default.createElement(
                  'td',
                  { className: 'email-tracking-cell' },
                  truncate(event.recipient, EMAIL_TRUNCATION_LENGTH)
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement(
                    'strong',
                    null,
                    (0, _capitalize3.default)(event.status)
                  ),
                  ' on ',
                  formatDateTime(event.occurred_at)
                )
              );
            })
          )
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return EmailTrackingTable;
}(_react.Component), _class2.propTypes = {
  emailDetails: _propTypes2.default.object.isRequired
}, _temp)) || _class) || _class;

var _default = EmailTrackingTable;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(truncate, 'truncate', '/app/src/components/page-case/EmailTrackingTable.js');
  reactHotLoader.register(formatDateTime, 'formatDateTime', '/app/src/components/page-case/EmailTrackingTable.js');
  reactHotLoader.register(EMAIL_TRUNCATION_LENGTH, 'EMAIL_TRUNCATION_LENGTH', '/app/src/components/page-case/EmailTrackingTable.js');
  reactHotLoader.register(EmailTrackingTable, 'EmailTrackingTable', '/app/src/components/page-case/EmailTrackingTable.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/EmailTrackingTable.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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